import { render, staticRenderFns } from "./DashboardOvertimeLimit.vue?vue&type=template&id=24f2fdf9&"
import script from "./DashboardOvertimeLimit.vue?vue&type=script&lang=js&"
export * from "./DashboardOvertimeLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports